import * as React from 'react';

import { VStack, View } from '@rbilabs/universal-components';
import { useWindowDimensions } from 'react-native';

import { BackArrowHistory } from 'components/navigation/back-arrow';
import AuthRequired from 'pages/authentication/components/auth-required';
import { useLoyaltyUser } from 'state/loyalty/hooks/use-loyalty-user';

import QuestList from './quest-card-list';

const Wrapper = VStack.withConfig<{
  $windowHeight: number;
}>(({ $windowHeight }) => ({
  height: '100%',
  maxHeight: $windowHeight,
  paddingY: '$2',
  paddingX: '$4',
}));

export const QuestLibrary = () => {
  const { height: $windowHeight } = useWindowDimensions();
  const { loyaltyUser } = useLoyaltyUser();
  const loyaltyId = loyaltyUser?.id;

  return (
    <View flex={1}>
      <AuthRequired>
        <BackArrowHistory />
        <Wrapper $windowHeight={$windowHeight}>
          {loyaltyId && <QuestList loyaltyId={loyaltyId} />}
        </Wrapper>
      </AuthRequired>
    </View>
  );
};
